export default "__VITE_ASSET__977fc5ea__"